module.exports = __webpack_public_path__ + "media/volvo/assets/images/google_play@2x-8da790e0b2512af24f0a5b2293094cc5.png";